module.exports = __webpack_public_path__ + "img/left_ear.a1c240da.svg";